import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '10,000+',
  label: 'Nonprofits Served'
}, {
  value: '$500M+',
  label: 'Donations Processed'
}, {
  value: '99.9%',
  label: 'Uptime Guarantee'
}, {
  value: '24/7',
  label: 'Support Available'
}];
export function TrustSection() {
  return <section className="py-24 lg:py-32 bg-slate-900 relative overflow-hidden" data-id="element-260">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-261">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
        backgroundSize: '48px 48px'
      }} data-id="element-262" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8" data-id="element-263">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-264">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4" data-id="element-265">
            Trusted by nonprofits nationwide
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-266">
            Join thousands of organizations making a difference with Master
            Merchant
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12" data-id="element-267">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-268">
              <div className="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent mb-2" data-id="element-269">
                {stat.value}
              </div>
              <div className="text-slate-400 font-medium" data-id="element-270">{stat.label}</div>
            </motion.div>)}
        </div>

        {/* Testimonial */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-20 max-w-3xl mx-auto" data-id="element-271">
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 lg:p-12 border border-white/10" data-id="element-272">
            <div className="flex gap-1 mb-6" data-id="element-273">
              {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-274">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-275" />
                </svg>)}
            </div>
            <p className="text-xl text-white leading-relaxed mb-6" data-id="element-276">
              "Master Merchant transformed how we handle donations. Setup was
              incredibly simple, and we were accepting payments within the hour.
              The support team truly understands nonprofit needs."
            </p>
            <div className="flex items-center gap-4" data-id="element-277">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-full" data-id="element-278" />
              <div data-id="element-279">
                <div className="text-white font-semibold" data-id="element-280">Sarah Johnson</div>
                <div className="text-slate-400 text-sm" data-id="element-281">
                  Executive Director, Hope Foundation
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}